import React from 'react';

export default () => (
    <div style={{margin: '100px'}}>
        <h1> Not found</h1>
    </div>
    
);